require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
module.exports = require('../modules/_core').Set;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/set.js
// module id = 124
// module chunks = 0 3